import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instance22vwyocs8eppk as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contentType2zzm38yxo3syt as contentType } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  toString30pk9tzaqopn as toString_0,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { trimMarginhyd3fsmh8iev as trimMargin } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { get_MaxRetriesPerRequestAttributeKey13gphm9kuo852 as get_MaxRetriesPerRequestAttributeKey } from './HttpRequestRetry.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { cancel36mj9lv3a0whl as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from '../call/HttpClientCall.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpSend$Plugin$install$slambda($plugin, $scope) {
  return constructCallableReference(($this$intercept, content, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.check' call
    if (!(content instanceof OutgoingContent())) {
      var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString(getKClassFromExpression(content)) + ', with Content-Type: ' + toString_0(contentType($this$intercept.context_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
    }
    var tmp0 = $this$intercept.context_1;
    // Inline function 'io.ktor.client.request.setBody' call
    var body = content;
    if (body == null) {
      tmp0.body_1 = NullBody_instance;
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(OutgoingContent());
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(OutgoingContent()), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$4 = tmp_0;
      var tmp$ret$3 = new (TypeInfo())(tmp, tmp$ret$4);
      tmp0.set_bodyType_8pgqkl_k$(tmp$ret$3);
    } else {
      if (body instanceof OutgoingContent()) {
        tmp0.body_1 = body;
        tmp0.set_bodyType_8pgqkl_k$(null);
      } else {
        tmp0.body_1 = body;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_2 = getKClass(OutgoingContent());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_3;
        try {
          tmp_3 = createKType(getKClass(OutgoingContent()), arrayOf([]), false);
        } catch ($p_0) {
          var tmp_4;
          if ($p_0 instanceof Error) {
            var _unused_var__etf5q3_0 = $p_0;
            tmp_4 = null;
          } else {
            throw $p_0;
          }
          tmp_3 = tmp_4;
        }
        var tmp$ret$6 = tmp_3;
        var tmp$ret$5 = new (TypeInfo())(tmp_2, tmp$ret$6);
        tmp0.set_bodyType_8pgqkl_k$(tmp$ret$5);
      }
    }
    var maxRetries = $this$intercept.context_1.attributes_1.getOrNull_6mjt1v_k$(get_MaxRetriesPerRequestAttributeKey());
    var tmp_5;
    if (!(maxRetries == null) && maxRetries >= $plugin.maxSendCount_1) {
      var tmp_6;
      if (maxRetries < 2147483647) {
        tmp_6 = maxRetries + 1 | 0;
      } else {
        tmp_6 = maxRetries;
      }
      tmp_5 = tmp_6;
    } else {
      tmp_5 = $plugin.maxSendCount_1;
    }
    var maxSendCount = tmp_5;
    var realSender = new (DefaultSender())(maxSendCount, $scope);
    var interceptedSender = realSender;
    var _iterator__ex2g4s = reversed($plugin.interceptors_1).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var interceptor = _iterator__ex2g4s.next_20eer_k$();
      interceptedSender = new (InterceptedSender())(interceptor, interceptedSender);
    }
    var call = yield* interceptedSender.execute_utzngx_k$($this$intercept.context_1, $completion);
    yield* $this$intercept.proceedWith_i5skhv_k$(call, $completion);
    return Unit_instance;
  }), 2);
}
var ConfigClass;
function Config() {
  if (ConfigClass === VOID) {
    class $ {
      constructor() {
        this.maxSendCount_1 = 20;
      }
    }
    initMetadataForClass($, 'Config', Config);
    ConfigClass = $;
  }
  return ConfigClass;
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'HttpSend';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(HttpSend());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(HttpSend()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.key_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      get_key_18j28a_k$() {
        return this.key_1;
      }
      prepare_dfz635_k$(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Config())();
        block(this_0);
        var config = this_0;
        return new (HttpSend())(config.maxSendCount_1);
      }
      prepare_t1xtpw_k$(block) {
        return this.prepare_dfz635_k$(block);
      }
      install_crmqtp_k$(plugin, scope) {
        var tmp = Phases_getInstance().Send_1;
        scope.requestPipeline_1.intercept_k21bv3_k$(tmp, HttpSend$Plugin$install$slambda(plugin, scope));
      }
      install_zd7cej_k$(plugin, scope) {
        return this.install_crmqtp_k$(plugin instanceof HttpSend() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var InterceptedSenderClass;
function InterceptedSender() {
  if (InterceptedSenderClass === VOID) {
    class $_0 {
      constructor(interceptor, nextSender) {
        this.interceptor_1 = interceptor;
        this.nextSender_1 = nextSender;
      }
      *execute_utzngx_k$(requestBuilder, $completion) {
        return yield* $(this.interceptor_1(this.nextSender_1, requestBuilder, $completion), $completion);
      }
    }
    initMetadataForClass($_0, 'InterceptedSender', VOID, VOID, VOID, [1]);
    InterceptedSenderClass = $_0;
  }
  return InterceptedSenderClass;
}
var DefaultSenderClass;
function DefaultSender() {
  if (DefaultSenderClass === VOID) {
    class $ {
      constructor(maxSendCount, client) {
        this.maxSendCount_1 = maxSendCount;
        this.client_1 = client;
        this.sentCount_1 = 0;
        this.currentCall_1 = null;
      }
      *execute_utzngx_k$(requestBuilder, $completion) {
        var tmp0_safe_receiver = this.currentCall_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          cancel(tmp0_safe_receiver);
        }
        if (this.sentCount_1 >= this.maxSendCount_1) {
          throw SendCountExceedException().new_io_ktor_client_plugins_SendCountExceedException_s608fg_k$('Max send count ' + this.maxSendCount_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
        }
        this.sentCount_1 = this.sentCount_1 + 1 | 0;
        var sendResult = yield* this.client_1.sendPipeline_1.execute_qsx0hz_k$(requestBuilder, requestBuilder.body_1, $completion);
        var tmp1_elvis_lhs = sendResult instanceof HttpClientCall() ? sendResult : null;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString(sendResult);
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var call = tmp;
        this.currentCall_1 = call;
        return call;
      }
    }
    initMetadataForClass($, 'DefaultSender', VOID, VOID, VOID, [1]);
    DefaultSenderClass = $;
  }
  return DefaultSenderClass;
}
var HttpSendClass;
function HttpSend() {
  if (HttpSendClass === VOID) {
    class $ {
      constructor(maxSendCount) {
        Plugin_getInstance();
        maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
        this.maxSendCount_1 = maxSendCount;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.interceptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      intercept_abqmrc_k$(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.interceptors_1.add_utx5q5_k$(block);
      }
    }
    initMetadataForClass($, 'HttpSend');
    HttpSendClass = $;
  }
  return HttpSendClass;
}
var SendCountExceedExceptionClass;
function SendCountExceedException() {
  if (SendCountExceedExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(message) {
        return new.target.new_io_ktor_client_plugins_SendCountExceedException_s608fg_k$(message);
      }
      static new_io_ktor_client_plugins_SendCountExceedException_s608fg_k$(message) {
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'SendCountExceedException');
    SendCountExceedExceptionClass = $;
  }
  return SendCountExceedExceptionClass;
}
//region block: exports
export {
  Plugin_getInstance as Plugin_getInstancedvtd2m29fslb,
};
//endregion

//# sourceMappingURL=HttpSend.mjs.map
